/*
 * Removes all non-digit or non-+ characters from an MDN
 * +1 (555) 555-0100 -> +15555550100
 */
export function removeMdnFormatting(mdn: string): string {
    return mdn.replace(/[^\d+]/g, "");
}
